import React from 'react';
import { LoadingBounce } from '@michelin/acid-components';

export const LoadingForm = () => (
  <div style={{ position: 'absolute', zIndex: 9, width: '95%' }}>
    <LoadingBounce style={{ height: '70vh' }} />
  </div>
);
